export function createFinanceRequestGate() {
  let current: { controller: AbortController; kind: "load" | "poll" | "command" } | null = null;
  return {
    begin(kind: "load" | "poll" | "command") {
      if (current && !current.controller.signal.aborted && (current.kind === "command" || kind === "poll")) return null;
      current?.controller.abort();
      const controller = new AbortController();
      current = { controller, kind };
      return controller;
    },
    owns(controller: AbortController) { return current?.controller === controller && !controller.signal.aborted; },
    finish(controller: AbortController) { if (current?.controller === controller) current = null; },
    cancel() { current?.controller.abort(); current = null; },
  };
}
